// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type Scope } from "~/hooks/useScope";
import { SET_BUNDLE } from "./action";

export function canSetBundle(scope: Scope): boolean {
  return scope.iamActions.includes(SET_BUNDLE);
}
